import React from 'react';
import { HowToRegOutlinedIcon } from 'assets/icons';
import { Card, CardContent, Stack, Typography } from 'components/base';
import GetItOnGooglePlayIcon from 'assets/img/GetItOnGooglePlay.png';
import GetItOnAppStoreIcon from 'assets/img/GetItOnAppStore.png';
import {
  VARICON_TIMESHEET_APP_ON_APPLE_STORE_URL,
  VARICON_TIMESHEET_APP_ON_GOOGLE_PLAY_URL,
} from 'config/constants';
import { iconDiv } from '../../styles';
import { useQRStore } from '../../store/useQRStore';

const steps = [
  '1. Open the Varicon Timesheet app',
  '2. Go to Forms Tab',
  '3. Use Scan QR button at the bottom to fill the form.',
];

export const VariconEmployeeDetail: React.FC = () => {
  const { userDetail } = useQRStore();

  return (
    <Card raised sx={{ maxWidth: '80%' }}>
      <CardContent>
        <Stack p={{ xs: 1, md: 2 }} spacing={{ xs: 1, md: 2 }}>
          <Stack sx={iconDiv} bgcolor="success.background">
            <HowToRegOutlinedIcon fontSize="large" color="success" />
          </Stack>
          <Stack alignItems="center" p={1} spacing={{ xs: 1, md: 2 }}>
            <Typography variant="h6" color="text.primary">
              Hi {userDetail?.first_name}!
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Looks like you are an registered employee of{' '}
              <strong>{userDetail?.company_name}. </strong> Please use{' '}
              <strong>Varicon Timesheet</strong> app to submit this form.
            </Typography>
            <Stack width="100%" p={2} bgcolor="grey.g200" borderRadius={2}>
              {steps.map((item) => (
                <Typography variant="body2" color="text.secondary" key={item}>
                  {item}
                </Typography>
              ))}
            </Stack>
            <Typography variant="caption" color="text.secondary">
              If you do not have app installed, please use link below to install
              it on your device
            </Typography>
            <Stack
              direction="row"
              width="100%"
              justifyContent="center"
              spacing={1}
            >
              <img
                src={GetItOnGooglePlayIcon}
                alt="Get It On Google Play"
                onClick={() =>
                  window.open(
                    VARICON_TIMESHEET_APP_ON_GOOGLE_PLAY_URL,
                    '_blank',
                  )
                }
              />
              <img
                src={GetItOnAppStoreIcon}
                alt="Get It On App Store"
                onClick={() =>
                  window.open(
                    VARICON_TIMESHEET_APP_ON_APPLE_STORE_URL,
                    '_blank',
                  )
                }
              />
            </Stack>
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
};
